import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ErrorSectionStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 2rem 5rem;
`;

export const ErrorTitleStyled = styled.h2`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  color: ${colors.red[600]};
  font-size: 2.2rem;
  text-transform: capitalize;
  line-height: 2.2rem;
  letter-spacing: 0.02rem;
  margin-bottom: 3rem;
  justify-content: center;
`;

export const ErrorMessageStyled = styled.p`
  font-size: 1.8rem;
  line-height: 2.8rem;
  color: ${colors.neutral[900]};
  border-radius: 10px;
  padding: 2rem 3rem;
  background-color: ${colors.neutral[100]};
  margin-bottom: 4rem;
`;

export const ActionSectionStyled = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 2rem;
`;
